import moment from "moment";
import lodash from "lodash";
import _momentTimezone from "moment-timezone";
import xmlFormat from "xml-formatter";
import { parse } from "query-string";

/**
 * getServerUrl - returns current host
 * @returns {string}
 */
export function getServerUrl() {
  return window.location.protocol + "//" + window.location.host;
}

/**
 * getLocalDateTime - returns date time in local timezone
 * @param {string} dateTime
 * @returns {string}
 */
export function getLocalDateTime(dateTime) {
  const format = "YYYY-MM-DD HH:mm:ss A z";
  const zone = moment.tz.guess();
  // Convert to local
  const offset = moment().utcOffset();
  let dateTimeLocal = moment
    .utc(dateTime)
    .utcOffset(offset)
    .tz(zone)
    .format(format);

  return dateTimeLocal;
}

/**
 * isClientError
 * @param {*} error
 * @returns {boolean}
 */
export function isClientError(error) {
  return lodash.has(error, "message") && lodash.has(error, "stack");
}

/**
 * isMPXError
 * @param {*} error
 * @returns {boolean}
 */
export function isMPXError(error) {
  if (
    lodash.has(error, ["response", "data"]) &&
    error.response.data.isException
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * Check if a string is JSON
 * @param {string} str
 * @returns {boolean}
 */
export function IsJson(str) {
  try {
    let parsedVal = JSON.parse(str);
    if (typeof parsedVal === "string" || typeof parsedVal === "number") {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function convertXMLToSingleLine(inputString) {
  let singleLineXML = lodash.replace(inputString, /(?:\r\n|\r|\n)/g, "");

  return singleLineXML;
}

export function convertXMLToMultiLine(inputString) {
  let singleLineXML = lodash.replace(inputString, /(?:\r\n|\r|\n)/g, "");
  let prettyXML = xmlFormat(singleLineXML, {
    indentation: "  ",
    filter: node => node.type !== "Comment",
    collapseContent: false,
    lineSeparator: "\n"
  });

  return prettyXML;
}

export function escapeXMLString(inputString) {
  return inputString
    .replace(/\n/g, "\\n")
    .replace(/'/g, "'")
    .replace(/"/g, '"');
}

export function unEscapeXMLString(inputString) {
  return inputString
    .replace(/\\n/g, "\n")
    .replace(/\'/g, "'")
    .replace(/\"/g, '"');
}

export function escapeSpecialChars(inputString) {
  return (
    inputString
      .replace(/\n/g, "\\n")
      .replace(/'/g, "\\'")
      .replace(/"/g, '\\"')
      .replace(/&/g, "\\&")
      .replace(/\r/g, "\\r")
      .replace(/\t/g, "\\t")
      // .replace(/\b/g, "\\b")
      .replace(/\f/g, "\\f")
  );
}

export function unEscapeSpecialChars(inputString) {
  return (
    inputString
      .replace(/\\n/g, "\n")
      .replace(/\\'/g, "'")
      .replace(/\\"/g, '"')
      .replace(/\\&/g, "&")
      .replace(/\\r/g, "\r")
      .replace(/\\t/g, "\t")
      // .replace(/\b/g, "\\b")
      .replace(/\\f/g, "\f")
  );
}



// WEBPACK FOOTER //
// ./src/Shared/utils.js